import React from "react";
import { Link } from "react-router-dom";
import LocalShippingRoundedIcon from "@mui/icons-material/LocalShippingRounded";
import ArrowForwardRoundedIcon from "@mui/icons-material/ArrowForwardRounded";
import CheckCircleRoundedIcon from "@mui/icons-material/CheckCircleRounded";
import ctaImage from "assets/img/premium-logistics-cta-branded.jpg";

const benefits = ["Reliable Partners", "Competitive Rates", "Nationwide Coverage", "Dedicated Support"];

export default function FinalCTA() {
  return (
    <section className="pl-final pl-reveal" id="fleet-partners" aria-labelledby="pl-final-title">
      <img
        src={ctaImage}
        alt="Cargo truck travelling on a mountain highway in the Philippines"
        width="1774"
        height="887"
        loading="lazy"
      />
      <div className="pl-final__shade" aria-hidden="true" />
      <div className="pl-container pl-final__inner">
        <div className="pl-final__copy">
          <p className="pl-eyebrow pl-eyebrow--light">Let&apos;s move the Philippines forward</p>
          <h2 id="pl-final-title">Ready to Ship?</h2>
          <p>Join thousands of businesses already using Garahex.</p>
          <div className="pl-final__buttons">
            <Link className="pl-button pl-button--primary" to="/addbookings">
              <LocalShippingRoundedIcon aria-hidden="true" />
              Book a Shipment
              <ArrowForwardRoundedIcon aria-hidden="true" />
            </Link>
            {/* The current public business registration flow is provided by /login. */}
            <Link className="pl-button pl-button--outline-light" to="/login">Create a Business Account</Link>
          </div>
        </div>
        <ul className="pl-final__benefits" aria-label="Reasons to choose Garahex">
          {benefits.map((benefit) => (
            <li key={benefit}><CheckCircleRoundedIcon aria-hidden="true" /> {benefit}</li>
          ))}
        </ul>
      </div>
    </section>
  );
}
